import { Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[emailOnly]',
})
export class EmailOnlyDirective implements OnChanges {
  private navigationKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste',
  ];

  @Input() allowPaste = true;
  inputElement: HTMLInputElement;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allowPaste']) {
      this.allowPaste = changes['allowPaste'].currentValue;
    }
  }

  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent): void {
    const invalidChars = /[^a-zA-Z0-9@._-]/;
    if (invalidChars.test(event.data)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.navigationKeys.includes(event.key) ||
      (event.ctrlKey && ['c', 'v', 'a', 'x'].includes(event.key.toLowerCase())) ||
      (event.metaKey && ['c', 'v', 'a', 'x'].includes(event.key.toLowerCase()))) {
      return; 
    }
    const validChars = /[a-zA-Z0-9@._-]/;
    if (!validChars.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (this.allowPaste) {
      const pastedContent = event.clipboardData?.getData('text') || '';
      const sanitizedContent = this.sanitizeInput(pastedContent);
      this.inputElement.value = sanitizedContent;
      event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  private sanitizeInput(input: string): string {
    const sanitized = input.replace(/[^a-zA-Z0-9@._-]/g, '');
    return sanitized;
  }
}
